var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdminsColored(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 78.75V71.25C60 67.2718 58.4196 63.4564 55.6066 60.6434C52.7936 57.8304 48.9782 56.25 45 56.25H18.75C14.7718 56.25 10.9564 57.8304 8.1434 60.6434C5.33035 63.4564 3.75 67.2718 3.75 71.25V78.75",
    stroke: "#5570F1",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.75 41.25L71.25 48.75L86.25 33.75",
    stroke: "#00FF47",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.875 41.25C40.1593 41.25 46.875 34.5343 46.875 26.25C46.875 17.9657 40.1593 11.25 31.875 11.25C23.5907 11.25 16.875 17.9657 16.875 26.25C16.875 34.5343 23.5907 41.25 31.875 41.25Z",
    stroke: "#5570F1",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminsColored);
export default __webpack_public_path__ + "static/media/admins-colored.7ecc6138dc4968504a2bfb6aad43184d.svg";
export { ForwardRef as ReactComponent };